import React from "react";
import { User, LogOut } from "lucide-react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth, updateActiveTab } from "../features/featuresSlice";
import Cookies from "js-cookie";

export default function Header({ isOpen, onToggle, menuRef }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove('token');
    dispatch(updateAuth(false));
    dispatch(updateActiveTab('stores'));
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-50 flex justify-between items-center px-8 py-4 bg-white shadow-sm">
      <div className="flex items-center">
        <div className="bg-[#2962FF] text-white w-8 h-8 rounded-md flex items-center justify-center mr-2">
          <span className="font-bold">D</span>
        </div>
        <span className="font-bold text-xl">DingAI</span>
      </div>
      <div className="relative" ref={menuRef}>
        <button
          className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
          onClick={onToggle}
        >
          <User size={20} />
        </button>
        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
            <button
              onClick={handleLogout}
              className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
